import { Dialog, Box, Breakpoint } from '@mui/material'

/**
 * @typedef {object} DialogWrapperPaperProps - Props for the DialogWrapperPaper component.
 * @property {any} children - The content to render within the component.
 * @property {boolean} isOpen - Indicates whether the dialog is open.
 * @property {function} closeModal - A function to close the dialog.
 * @property {false | Breakpoint | undefined} [maxWidth] - The maximum width of the dialog.
 */
interface DialogWrapperPaper {
  children: any
  isOpen: boolean
  closeModal: () => void
  maxWidth?: false | Breakpoint | undefined
}

/**
 * Renders a dialog wrapper component.
 *
 * @param {DialogWrapperPaper} props - The props for the DialogWrapper component.
 * @returns {JSX.Element} The rendered DialogWrapper component.
 */
export function DialogWrapper({ isOpen, closeModal, children, maxWidth = 'md' }: DialogWrapperPaper): JSX.Element {
  return (
    <Dialog open={isOpen} onClose={closeModal} maxWidth={maxWidth} fullWidth>
      <Box sx={{ margin: 1, padding: 1 }}>{children}</Box>
    </Dialog>
  )
}
